import styles from './loader.module.scss';

const Loader = () => (
  <div className={styles.loaderContainer}>
    <div className={styles.triangle}>
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Loader;
